import { combineReducers } from "redux";
import { allReducers } from "@onquality/dashboard-ui/lib/store/allReducers";

export const rootReducer = combineReducers({
    ...allReducers
});
